module.exports = __webpack_public_path__ + "static/img/12.3c46dff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/12.png
// module id = SOZD
// module chunks = 0